import React from 'react'

const Subheader = ({ text }) => {
  return <h4 className='alex-subheader'>{text}</h4>
}

export default Subheader
